export const ProgramsStateInitialState: ProgramsStateTypes = {
  programColumns: { pinnedColumn: [`widget`] },
  hasInitialized: false,
};
